import * as React from "react";
import { connect } from "react-redux";
import { withRouter, NavLink } from "react-router-dom";

import { FormattedMessage, InjectedIntlProps, injectIntl } from "react-intl";

// import { History } from "history";

// import * as CSS from "csstype";

/* eslint-disable import/no-webpack-loader-syntax */
import FailedIcon from "-!svg-react-loader!../../images/icn-failure.svg";
import SpinnerIcon from "../../images/spinner.png"
/* eslint-enable import/no-webpack-loader-syntax */

import "../login-page/styles.css";
import "./styles.css";

import {
  Button,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Row,
  Col,
  Alert
} from "react-bootstrap";

import { userActions } from "../../actions/user.actions";
// import { IAuthenticationState } from "../../contracts/IAuthenticationState";
import { IRootState } from "../../reducers";
import { ILocalizedError } from "src/i18n/error-localization";
import { ResetPasswordResult } from "src/contracts/IResetPasswordState";

// import { ILocalizedError } from "src/i18n/error-localization";
// import { loginMessages } from "./messages";

// import Footer from "./footer";

interface IProps extends InjectedIntlProps {
  error: ILocalizedError;
  isLoading: boolean;
  result: ResetPasswordResult;
  onResetPassword: (login: string) => void;
}

interface IState {
  loading: boolean;
  username: string;
}

class ResetPasswordPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      loading: false,
      username: ""
    };

    this.handleChange = this.handleChange.bind(this);
  }

  public componentDidMount() {
    document.body.classList.remove("main-body-theme");
    document.body.classList.add("login-body-theme");
  }

  public handleChange(e: any) {
    const { name, value } = e.target;
    this.setState(prevState => ({
      ...this.state,
      [name]: value
    }));
  }

  public render() {
    const { username, loading } = this.state;
    const { error, result } = this.props;

    return (
      <div className="container-fluid">
        <Row>
          <Col>
            <h1
              style={{ fontWeight: 700, color: "#fff", paddingBottom: "100px" }}
            >
              <FormattedMessage
                id="login-page.reset.title"
                defaultMessage="Password Recovery"
              />
            </h1>
          </Col>
        </Row>
        <div>
          <Form inline={true} onSubmit={this.handleResetPassword}>
            <FormGroup className="login-input">
              <ControlLabel>
                <FormattedMessage
                  id="login-page.username.label"
                  defaultMessage="username"
                />
              </ControlLabel>
              <FormControl
                name="username"
                type="text"
                onChange={e =>
                  this.setState({
                    username: (e.target as HTMLInputElement).value
                  })
                }
                value={username}
              />
              <NavLink to="/login" className="link-back-login">
              <FormattedMessage
                id="login-page.reset.back-to-login"
                defaultMessage="Back To Login"
              />
              </NavLink>
            </FormGroup>
            <Button type="submit" className="login-button" disabled={loading}>
              <FormattedMessage
                id="login-page.reset.button"
                defaultMessage="Reset Password"
              />
            </Button>
          </Form>
          {result !== undefined && result !== ResetPasswordResult.Success && (
            <Alert bsStyle="warning" className="validation_message">
              <FailedIcon className="failed-icon" />{" "}
              <FormattedMessage
                id={error.id || ""}
                defaultMessage={error.defaultMessage}
              />
            </Alert>
          )}
          {this.props.isLoading && !error && (
            <img alt="" src={SpinnerIcon} className="spinner" />
          )}
        </div>
      </div>
    );
  }

  private handleResetPassword = (e: React.FormEvent<Form>) => {
    e.preventDefault();
    this.props.onResetPassword(this.state.username);
  };
}

const mapStateToProps = (state: IRootState, ownProps: any) => ({
  error: state.resetPasswordState.error,
  isLoading: state.resetPasswordState.isLoading,
  result: state.resetPasswordState.result
});

const mapDispatchToProps = (dispatch: any) => ({
  onResetPassword: (login: string) => dispatch(userActions.resetPassword(login))
});

const connectedLoginPage = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(ResetPasswordPage))
);

export { connectedLoginPage as ResetPasswordPage };



// WEBPACK FOOTER //
// ./src/scenes/reset-password-page/index.tsx